<template>
    <div class="container px-0">
        <div class="row mt-3">
            <div class="col-12">
                <search-input-component
                    placeholder="Search"
                    :emit_instead="true"
                    @change="search"
                    @submit="search"
                    v-show="selected === 'forms' && !form_submissions_preselection"
                ></search-input-component>
            </div>
            <div class="col-12">
                <job-issues-and-concerns-component
                    :load_url="issues_url"
                    :show_submission_url="show_submission_url"
                    v-if="selected === 'open_issues'"
                ></job-issues-and-concerns-component>

                <job-form-library-component
                    v-if="selected === 'forms'"
                    :forms="job.forms"
                    :search="search_text"
                    :load_url="load_url"
                    :edit_url="edit_url"
                    :show_submission_url="show_submission_url"
                    :pre_selected="form_submissions_preselection"
                    :url="timeline_formsubmissions_url"
                    :toggle_url="toggle_url"
                    :clone_url="clone_url"
                    :inspection_category_settings='inspection_category_settings'
                    :site_survey_url="site_survey_url"
                    :initial_briefing_submissions="initial_briefing_submissions"
                    :can_crud_jobs="can_crud_jobs"
                    :initial_briefing_show_url="initial_briefing_show_url"
                ></job-form-library-component>

                <job-this-week-component
                    v-if="selected === 'week'"
                    :load_url="this_week_url"
                    :show_submission_url="show_submission_url"
                    :back_url="back_url"
                ></job-this-week-component>

                <job-upcoming-component
                    v-if="selected === 'upcoming'"
                    :load_url="upcoming_url"
                ></job-upcoming-component>


                <job-quality-assurance-compliance-checks
                    v-if="selected === 'compliance_checks'"
                    :load_url="compliance_checks_url"
                    :show_location_url="show_location_url"
                    :back_url="back_url"
                ></job-quality-assurance-compliance-checks>

				<job-archived-form-submissions
					v-if="selected === 'archive'"
					:load_url="archived_url"
					:show_submission_url="show_submission_url"
					:back_url="back_url"
				></job-archived-form-submissions>
            </div>
        </div>
    </div>
</template>

<script>
	import JobIssuesAndConcernsComponent from "../jobs/JobIssuesAndConcernsComponent";
	import JobThisWeekComponent from "../jobs/JobThisWeekComponent";
	import JobFormLibraryComponent from "../jobs/JobFormLibraryComponent";
	import JobUpcomingComponent from "../jobs/JobUpcomingComponent";
	import SearchInputComponent from "../general_components/SearchInputComponent";
	import JobArchivedFormSubmissions from "../jobs/JobArchivedFormSubmissions";
    import JobQualityAssuranceComplianceChecks from "../jobs/JobQualityAssuranceComplianceChecks";
	export default {
		name: "TimelinePage",
		components: {
			JobArchivedFormSubmissions,
			SearchInputComponent,
			JobUpcomingComponent, JobFormLibraryComponent, JobThisWeekComponent, JobIssuesAndConcernsComponent, JobQualityAssuranceComplianceChecks},
		props: [
        	'job',
            'load_url',
			'archived_url',
            'show_submission_url',
            'this_week_url',
            'issues_url',
            'upcoming_url',
            'header_content',
            'selected',
            'form_submissions_preselection',
            'timeline_formsubmissions_url',
            'back_url',
            'compliance_checks_url',
            'show_location_url',
            'ssow_periods',
            'download_ssow_url',
            'toggle_url',
            'edit_url',
            'clone_url',
            'inspection_category_settings',
            'site_survey_url',
            'initial_briefing_submissions',
            'can_crud_jobs',
            'initial_briefing_show_url'
        ],

        data(){
			return {
				search_text: '',
            }
        },

        methods: {
			search(data){
				this.search_text = data;
            }
        },
	}
</script>
